<nav>
  <div class="navbar-wrapper">
    <app-nav-logo [navCollapsed]="navCollapsed" (onNavCollapse)="navCollapse()"></app-nav-logo>
    <app-nav-content (onNavCollapsedMob)="navCollapseMob()" [userData]="userData"></app-nav-content>
  </div>
</nav>
